// Types for the component props
export type Position =
    | "bottom-right"
    | "bottom-left"
    | "top-right"
    | "top-left";
export type ButtonSize = "small" | "medium" | "large";
export type Theme = "light" | "dark";
export type ButtonIcon = "feedback" | "chat" | "message" | "feedaura" | "none";
export type WidgetStyle = "floating" | "minimal" | "solid";

export interface FeedbackProps {
    projectSecret?: string;
    position?: Position;
    primaryColor?: string;
    secondaryColor?: string;
    textColor?: string;
    backgroundColor?: string;
    theme?: Theme;
    buttonText?: string;
    buttonIcon?: ButtonIcon;
    iconColor?: string;
    buttonSize?: ButtonSize;
    buttonRadius?: string;
    widgetStyle?: WidgetStyle;
    zIndex?: number;
    autoCloseAfterSubmit?: boolean;
    apiEndpoint?: string;
    animated?: boolean;
    productName?: string;
    placeholder?: string;
    submitText?: string;
    headerText?: string;
    questionText?: string;
    feedbackLabelText?: string;
}

export interface IconProps {
    size?: number;
    color?: string;
    animated?: boolean;
}

// src/components/Feedback.tsx

// → make icons a bit larger
export const ICON_SIZE_MAP: Record<ButtonSize, number> = {
    small: 24,
    medium: 32,
    large: 40,
};
